import { signOut } from "firebase/auth";

import { auth } from "@/api/firebase";

export const SESSION_KEY = "carmen.session.expiresAt";

export function getSessionTtlMs(): number {
  const hours = Number(import.meta.env.VITE_SESSION_TTL_HOURS ?? 24);
  return hours * 60 * 60 * 1000;
}

export function loginAndSetSessionExpiry(): void {
  const nextExpiry = Date.now() + getSessionTtlMs();
  localStorage.setItem(SESSION_KEY, String(nextExpiry));
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY);
}

export async function logout(): Promise<void> {
  try {
    await signOut(auth);
  } finally {
    clearSession();
  }
}


